module.exports = __webpack_public_path__ + "static/media/profile-original.f2f0b305.jpg";